import { render, staticRenderFns } from "./set-configuration.vue?vue&type=template&id=be07edbe&"
import script from "./set-configuration.vue?vue&type=script&lang=js&"
export * from "./set-configuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports